import { z } from 'zod'

export const caseSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  status: z.enum(['New', 'Working', 'Escalated', 'Resolved', 'Closed']),
  origin: z.enum(['Email', 'Teléfono', 'Web']),
  priority: z.enum(['Low', 'Medium', 'High', 'Media']),
  contactName: z.string().optional(),
  accountName: z.string().optional(),
  description: z.string().optional(),
})

export type CaseFormData = z.infer<typeof caseSchema>
